import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GeneralLedgerMemoToggleComponent } from './general-ledger-memo-toggle.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedModule } from '../../../../shared/shared.module';


@NgModule({
    declarations: [
        GeneralLedgerMemoToggleComponent,
    ],
    imports: [
        CommonModule,
        MatSlideToggleModule,
        MatTooltipModule,
        SharedModule,
    ],
    exports: [
        GeneralLedgerMemoToggleComponent,
    ],
})
export class GeneralLedgerMemoToggleModule
{
}
